export class AssetSortField {
    static readonly Publisher: number = 1;
    static readonly Name: number = 2;
    static readonly VideoUrl: number = 3;
    static readonly ProcessingStatus: number = 4;
}


// WEBPACK FOOTER //
// ./src/app/assets/asset-sort.enum.ts